<template>
  <div class="inputs-block">
    <BlockHeader name="External Company Deployment" />
    <div>
      <AddCompany
        id="addShiftComapny"
        :onSave="addNewCompany"
        :selectedEntity="companies"
        header="Add Company"
        :list="companiesList"
        entity="Company"
        v-if="companiesList"
      />
      <AddNewCompany :afterSave="createNewCompany" />
      <div v-if="companies">
        <div class="row user-line" v-for="c in companies" :key="c.id">
          <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
            <div class="user-name">
              <span>{{ c.company }}</span>
            </div>
          </div>
          <div class=" col-lg-7 col-sm-12 col-xs-12 input-log-line">
            <Input v-model="value[c.id]" placeholder="Comments" :viewMode="!isMyTeam" :formGroupId="c.id" />
          </div>
          <div class=" col-lg-2 col-sm-12 col-xs-12 button-log-line mt-4 pt-1" v-if="isMyTeam">
            <div class="delete-button" @click="deleteCompany(c)">
              {{ 'Delete' | i18n }}
            </div>
          </div>
        </div>
      </div>
      <Loader v-else />
      <b-button variant="outline-primary" size="sm" v-b-modal.addShiftComapny v-if="isMyTeam">
        {{ 'Add Company' | i18n }}
      </b-button>
      <b-button variant="outline-primary" style="margin-left:20px" size="sm" v-b-modal.addCompany v-if="isMyTeam">
        {{ 'Create New Company' | i18n }}
      </b-button>
    </div>
  </div>
</template>

<script>
import BlockHeader from '../../../../common/block-header';
import Input from '../../../../common/input';
import AddCompany from './add-entity';
import AddNewCompany from './add-company';
import { DeleteRowMixin, AuthMixin } from '../../../../../../mixins';
import api from '../../../../../api';

export default {
  title: 'External Company Deployment',
  components: { BlockHeader, Input, AddCompany, AddNewCompany },
  mixins: [DeleteRowMixin, AuthMixin],
  props: {
    isMyTeam: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {}
    },
    updateCompanies: {
      type: Function,
      default: () => {}
    },
    companies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      companiesList: []
    };
  },
  async created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.companiesList = await api.suppliers.get();
    },
    async createNewCompany(company) {
      await this.initData();
      await this.addNewCompany(company);
    },
    addNewCompany(company) {
      const newCompanies = [...this.companies];
      newCompanies.push(company);
      this.updateCompanies(newCompanies);
    },
    async deleteCompany(company) {
      await this.deleteSelectedRows(null, () => {
        const newCompanies = [...this.companies];
        this.updateCompanies(newCompanies.filter(u => u.id !== company.id));
      });
    }
  }
};
</script>

<style scoped lang="scss">
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}

.user-name {
  font-size: 20px;
}
.user-email {
  font-size: 14px;
  color: #c7c7c7;
}

.user-line {
  padding: 10px 0;
  margin: 10px 0;
  box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
  .form-group {
    margin-bottom: 0px;
  }
}

.delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 8px 13px;
  margin: 0px 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
</style>
